import { configureStore } from '@reduxjs/toolkit'
import { setupListeners } from '@reduxjs/toolkit/query'
import searchReducer from './search/searchSlice'
import bookingsReducer from './bookings/bookingsSlice'
import mugshotsReducer from './mugshots/mugshotsSlice'

export const store = configureStore({
  reducer: {
    search: searchReducer,
    bookings: bookingsReducer,
    mugshots: mugshotsReducer,
  },
  middleware: (getDefaultMiddleware) => 
    getDefaultMiddleware().concat()
})

setupListeners(store.dispatch)

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch